import * as Constants from './Constants';

const initialState = {
  emailAndMTN: null,
  emailAndMTNError: null,
  inspicioTokenIds: null,
  inspicioTokenIdsError: null,
  sendSMS: null,
  sendSMSError: null,
  showForgetPinOption: null,
  showForgotPinFail: null,
  verifyPinReciveMsg: null,
  validatePin: null,
  validatePinFail: null,
  resendLinkData: null,
  sendOtpEmail: null,
  sendOtpEmailError: null,
  inspicioVerifyEmail: null,
  verifyEmailAuthCode: null,
  emailAuthtriggerMsg: null,
  emailAuthtriggerErrorMsg: null,
  emailOtpValidation: null,
  emailOtpValidationErrorMsg: null,
  emailAuthText: null,
  emailAuthTextErrorMsg: null,
  acceptPlans: null,
  confirmPlans: null,
  confirmPlansError: null,
  getPlan: null,
  getPlanError: null,
  updateCart: null,
  updateCartError: null,
  inspecioValidatePin: null,
  inspecioValidatePinFail: null,
  submitPlansResp: null,
  submitPlansError: null,
  retriewCart: null,
  retriewCartError: null,
  declinePlans: null,
  declinePlansError: null,
  sendDeclinePlans: null,
  sendDeclinePlansError: null,
  sendErrorMsg: null,
  sendErrorMsgFail: null,
  cBandQualSuccess: null,
  cBandQualFail: null,
  mtnEmailAPIStatus: '',
};

const eagleCPC = (state = initialState, action) => {
  switch (action.type) {
    case Constants.CPC_GET_EMAIL_AND_MTN_SUCCESS: return { ...state, emailAndMTN: action.response?.data };
    case Constants.CPC_GET_EMAIL_AND_MTN_FAIL: return { ...state, emailAndMTNError: action.response };
    case Constants.CPC_GEN_INSPICIO_ID_SUCCESS: return { ...state, inspicioTokenIds: action.response?.data };
    case Constants.CPC_GEN_INSPICIO_ID_FAIL: return { ...state, inspicioTokenIdsError: action.response };
    case Constants.CPC_SEND_SMS_EMAIL_INSPICIO_SUCCESS: return { ...state, sendSMS: action.response?.data };
    case Constants.CPC_SEND_SMS_EMAIL_INSPICIO_FAIL: return { ...state, sendSMSError: action.response ? action.response : 'sendSMS Failed' };
    case Constants.CPC_INSPECIO_SHOWFORGETPIN_SUCCESS: return { ...state, showForgetPinOption: action.response };
    case Constants.CPC_INSPECIO_SHOWFORGETPIN_FAIL: return { ...state, showForgotPinFail: action.response ? action.response : 'showForgotPin Failed' };
    case Constants.CPC_INSP_VERIFY_PIN: return { ...state, verifyPinReciveMsg: action.response };
    case Constants.CPC_VALIDATE_PIN_SUCCESS: return { ...state, validatePin: action.response };
    case Constants.CPC_VALIDATE_PIN_FAIL: return { ...state, validatePinFail: action.response ? action.response : 'ValidatePin Failed' };
    case Constants.CPC_RESEND_EMAIL_MTN_FLAGS: return { ...state, resendLinkData: action.data };
    case Constants.CPC_SEND_OTP_EMAIL_SUCCESS: return { ...state, sendOtpEmail: action.response };
    case Constants.CPC_SEND_OTP_EMAIL_FAIL: return { ...state, sendOtpEmailError: action.response };
    case Constants.CPC_VERIFY_EMAIL: return { ...state, inspicioVerifyEmail: action.response };
    case Constants.CPC_VERIFY_EMAIL_AUTH_CODE: return { ...state, verifyEmailAuthCode: action.response };
    case Constants.EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_SUCCESS: return { ...state, emailAuthtriggerMsg: action.response };
    case Constants.EMAIL_OTP_SEND_MSG_AUTH_TRIGGER_FAIL: return { ...state, emailAuthtriggerErrorMsg: action.response };
    case Constants.EMAIL_VALIDATE_OTP_SUCCESS: return { ...state, emailOtpValidation: action.response };
    case Constants.EMAIL_VALIDATE_OTP_FAIL: return { ...state, emailOtpValidationErrorMsg: action.response };
    case Constants.EMAIL_OTP_SEND_MSG_AUTH_TEXT_SUCCESS: return { ...state, emailAuthText: action.response };
    case Constants.EMAIL_OTP_SEND_MSG_AUTH_TEXT_FAIL: return { ...state, emailAuthTextErrorMsg: action.response };
    case Constants.CPC_ACCEPT_PLANS: return { ...state, acceptPlans: action.response };
    case Constants.CPC_PLANS_CONFIRMATION_SUCCESS: return { ...state, confirmPlans: action.response };
    case Constants.CPC_PLANS_CONFIRMATION_FAIL: return { ...state, confirmPlansError: action.response };
    case Constants.CPC_CBAND_QUALIFICATION_SUCCESS: return { ...state, cBandQualSuccess: action.response };
    case Constants.CPC_CBAND_QUALIFICATION_FAIL: return { ...state, cBandQualFail: action.response };
    case Constants.CPC_GETPLANS_SUCCESS: return { ...state, getPlan: action.response };
    case Constants.CPC_GETPLANS_FAIL: return { ...state, getPlanError: action.response ? action.response : 'GetPlans Failed' };
    case Constants.CPC_UPDATECART_SUCCESS: return { ...state, updateCart: action.response };
    case Constants.CPC_UPDATECART_FAIL: return { ...state, updateCartError: action.response ? action.response : 'UpdateCart Failed' };
    case Constants.CPC_INSPECIO_VALIDATEPIN_SUCCESS: return { ...state, inspecioValidatePin: action.response };
    case Constants.CPC_INSPECIO_VALIDATEPIN_FAIL: return { ...state, inspecioValidatePinFail: action.response ? action.response : 'UpdateCart Failed' };
    case Constants.CPC_PLANS_SUBMIT_SUCCESS: return { ...state, submitPlansResp: action.response };
    case Constants.CPC_PLANS_SUBMIT_FAIL: return { ...state, submitPlansError: action.response };
    case Constants.CPC_RETRIEVE_CART_SUCCESS: return { ...state, retriewCart: action.response };
    case Constants.CPC_RETRIEVE_CART_FAIL: return { ...state, retriewCartError: action.response };
    case Constants.CPC_DECLINE_PLANS_UPDATE: return { ...state, declinePlans: action.response };
    case Constants.CPC_SEND_DECLINE_PLANS_SUCCESS: return { ...state, sendDeclinePlans: action.response };
    case Constants.CPC_SEND_DECLINE_PLANS_FAIL: return { ...state, sendDeclinePlansError: action.response };
    case Constants.CPC_SEND_ERROR_MESSAGE_SUCCESS: return { ...state, sendErrorMsg: action.response };
    case Constants.CPC_SEND_ERROR_MESSAGE_FAIL: return { ...state, sendErrorMsgFail: action.response };
    case Constants.MTN_EMAIL_RESPONSE: return { ...state, mtnEmailAPIStatus: action.response };
    case Constants.CPC_INITIAL_STATE: return initialState;
    default: return state;
  }
};
export default eagleCPC;
